import { NORMAL, REGROUPEMENT } from '@/configuration/devisConf';
import { SANS_SUITE } from '@/configuration/optionBlocage/optionBlocage';

function getNomCommercialAnnonceur(devis) {
  const annonceur = devis.intervenants && devis.intervenants.find(i => i.annonceur);
  if (!annonceur) return '';
  return annonceur.nomCommercial;
}

function getAnneeMinDate(devis) {
  let minTime = null;
  if (devis.lignesCommande === null) return null;
  devis.lignesCommande.forEach(panneau => {
    if (panneau.type !== REGROUPEMENT
        || panneau.etatObtenu === SANS_SUITE
        || panneau.lignesCommande === null) return;
    panneau.lignesCommande.forEach(ligne => {
      if (ligne.type !== NORMAL || !ligne.dateDebut) return;
      const time = new Date(ligne.dateDebut).getTime();
      if (Number.isNaN(time)) return;
      if (minTime === null || time < minTime) minTime = time;
    });
  });
  if (!minTime) return null;
  return new Date(minTime).getFullYear();
}

export default function calculerThemeRecommandation(devis) {
  if (!devis) return '';
  const annee = getAnneeMinDate(devis);
  const nomCommercial = getNomCommercialAnnonceur(devis);
  if (!annee || !nomCommercial) return '';
  return `${annee} - ${nomCommercial}`;
}
